module.exports = __webpack_public_path__ + "img/footer_logo0.746d2dfd.jpg";